import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { paths } from "@libs/paths";
import styles from "./terms.module.css";
import type { NextPage } from "next";

const ReservationTermsPage: NextPage = () => {
  return (
    <CommonLayout noHeaderButton noModal hasFooter>
      <CommonHead
        title={"予約サービス利用規約"}
        ogUrl={paths.reservationTerms}
      />
      <div className={styles.terms}>
        <main className={styles.main}>
          <div className={styles.inner}>
            <div className={styles.termsTitle}>
              <h1>Fansta予約サービス利用規約</h1>
            </div>
            <p className={styles.termsDate}>
              2022年2月15日&emsp;制定
              <br />
              2023年4月20日&emsp;改定
              <br />
              2025年2月19日&emsp;改定
            </p>
            <ul>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第1条&emsp;はじめに</h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;Fansta（以下「本サービス」といいます）におけるスポーツ観戦施設（飲食店を含みますがそれに限られません。以下同じ。）の予約サービスをご利用になる場合にユーザーはこのFansta予約サービス利用規約（以下「本規約」といいます）にあらかじめ同意して利用するものとします。本規約はFansta利用規約の一部を構成するものとし、本規約で使用する用語は、本規約で特段の定めがない限り、Fansta利用規約と同一の意味を有するものとし、本規約で定めがない事項はFansta利用規約が適用されるものとします。なお、本規約とFansta利用規約の内容が矛盾する場合は、予約サービスに関しては本規約が優先するものとします。
                  </p>
                  <p>
                    2&emsp;スポーツ観戦施設は自己の責任においてスポーツ観戦イベント等のサービスについて提供しており、弊社は当該サービスの提供に関し何らの関与もしません。
                  </p>
                  <p>
                    3&emsp;ユーザーは、本サービスを通じてスポーツ観戦施設へ予約をする場合、自己の責任においてスポーツ観戦施設を利用するものとし、予約内容等のスポーツ観戦施設のサービスに関する問い合わせ・要望等は、当該スポーツ観戦施設に対して直接行うものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第2条&emsp;予約</h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;ユーザーが予約を行うと、予約時に入力された情報（個人情報を含みます）は直接当該スポーツ観戦施設に送信されます。
                  </p>
                  <p>
                    2&emsp;予約が成立すると当該スポーツ観戦施設から本サービスを通じてユーザーの指定するメールアドレスにその旨が通知されます。
                  </p>
                  <p>3&emsp;料金はスポーツ観戦施設に直接支払うものとします。</p>
                  <p>
                    4&emsp;予約の変更・取消などについては直接スポーツ観戦施設に行ってください。予約内容に関して弊社は一切関与しないものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第3条&emsp;禁止事項</h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;本サービスを通じて予約を行った場合、以下の行為は禁止しています。違反すると弊社が判断した場合またはスポーツ観戦施設より違反すると報告があった場合、弊社は、当該ユーザーに事前に通知することなく、本サービスの一部または全部の利用の停止、アカウント登録の削除、損害賠償請求等弊社が必要と認める措置（法的措置を含みますがこれに限りません。）を講じることができるものとします。
                    <br />
                    (1)&emsp;本サービスを通じた予約を無断でキャンセルする行為
                    <br />
                    (2)&emsp;スポーツ観戦施設が本サービス上でキャンセル料を定めていた場合の支払わない行為
                    <br />
                    (3)&emsp;同日の同時間帯に複数のスポーツ観戦施設へ予約する等、当該スポーツ観戦施設への来店や予約内容のサービスを受けることが不可能と認められるような行為
                    <br />
                    (4)&emsp;本サービスの予約内容入力画面において、スポーツ観戦施設への予約に関する内容以外の項目を入力する行為
                    <br />
                    (5)&emsp;本サービスの予約内容入力画面において、意図的に虚偽の情報を入力する行為
                    <br />
                    (6)&emsp;弊社、スポーツ観戦施設または第三者に対する迷惑行為
                    <br />
                    (7)&emsp;その他法令に違反する、または違反する恐れのある行為
                    <br />
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </main>
      </div>
    </CommonLayout>
  );
};

export default ReservationTermsPage;
